import PropTypes from 'prop-types';

/**
 * The period a widget's numbers cover (CT-5641).
 *
 * Thirteen of the twenty-nine types return a `period`, and until now not one
 * of them showed it. That is a real gap rather than a cosmetic one: a KPI
 * reading «126.000» means nothing without the window it was measured over, and
 * two widgets side by side on a dashboard can easily be measuring different
 * ones — a widget whose `follow_dashboard_date_filter` is false keeps its own
 * range while its neighbour follows the filter.
 *
 * The backend resolves the window and sends the label already written
 * («octubre 2026», «2026 a la fecha»), so this prints rather than computes. It
 * carries the exact bounds in `title`, because a label is for reading at a
 * glance and the dates are for when someone asks.
 */
function WidgetPeriodChip({ period, className = '' }) {
  if (!period?.label) return null;

  const bounds = period.start && period.end ? `${period.start} → ${period.end}` : undefined;

  return (
    <span
      title={bounds}
      className={[
        'inline-flex max-w-full items-center truncate rounded-md px-1.5 py-0.5',
        'text-[11px] font-medium text-content-secondary',
        'bg-[rgb(var(--wg-wash))]',
        className,
      ].filter(Boolean).join(' ')}
    >
      {period.label}
    </span>
  );
}

WidgetPeriodChip.propTypes = {
  /** The type's own `data.period`. Absent or unlabelled renders nothing. */
  period: PropTypes.shape({
    label: PropTypes.string,
    grain: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default WidgetPeriodChip;
